/**
 * 插入到 head 中, 预先执行的 JS 内容
 */

/* eslint no-console: 0 */
console.time('page load');



// WEBPACK FOOTER //
// ./src/preload.js